import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Firework1 from '../../../../../assets/images/metro/firework-1.svg';
import Firework2 from '../../../../../assets/images/metro/firework-2.svg';
import Firework3 from '../../../../../assets/images/metro/firework-3.svg';
import Firework4 from '../../../../../assets/images/metro/firework-4.svg';
import Firework5 from '../../../../../assets/images/metro/firework-5.svg';

export const Fireworks: React.FC = () => {
  const fireworks = [Firework1, Firework2, Firework3, Firework4, Firework5];

  const randomAnimationParams = fireworks.map(() => ({
    delay: `${1.5 + Math.random() * 2}s`,
    duration: `${2 + Math.random() * 1.5}s`,
  }));

  return (
    <div className={styles.wrapper}>
      {fireworks.map((src, index) => {
        const fireworkPositionClass = styles[`firework-${index + 1}`];

        return (
          <img
            key={index}
            src={src}
            alt={`Firework ${index + 1}`}
            style={{
              animationDelay: randomAnimationParams[index].delay,
              animationDuration: randomAnimationParams[index].duration,
            }}
            className={classNames(styles.blink, fireworkPositionClass)}
          />
        );
      })}
    </div>
  );
};

export default Fireworks;
